import { useQuery } from "@tanstack/react-query"
import { queryClient } from "~Shared/config/reactQueryConfig"
import GeoLocationService from "~Shared/services/geoLocation.service"

// Query for fetching location/address based on search text
export const useLocationQuery = (searchText: string, enabled: boolean = true) =>
    useQuery({
        queryKey: ["location", searchText],
        queryFn: async ({ signal }) => {
            const data = await GeoLocationService.fetchAddress(searchText, signal)

            return data
        },
        enabled: enabled && !!searchText?.trim(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
    })

export const INVALIDATE_GEOLOCATION_QUERY_KEY = ["address"]

export const invalidateGeolocation = async () => {
    await queryClient.invalidateQueries({
        queryKey: INVALIDATE_GEOLOCATION_QUERY_KEY,
    })
}
